// Liquor Studio — API client
const BASE = process.env.REACT_APP_BACKEND_URL;

const _get = async (path) => {
    const res = await fetch(`${BASE}${path}`);
    if (!res.ok) throw new Error(`API ${path} failed: ${res.status}`);
    return res.json();
};

const _post = async (path, body) => {
    const res = await fetch(`${BASE}${path}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body || {}),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const msg = (data && (data.detail || data.message)) || `Request failed (${res.status})`;
        const err = new Error(typeof msg === "string" ? msg : JSON.stringify(msg));
        err.status = res.status;
        err.data = data;
        throw err;
    }
    return data;
};

export const api = {
    siteSettings: () => _get("/api/site/settings"),
    products: (params = {}) => {
        const q = new URLSearchParams(params).toString();
        return _get(`/api/products${q ? `?${q}` : ""}`);
    },
    productCategories: () => _get(`/api/products/categories`),
    product: (slug) => _get(`/api/products/${slug}`),
    blog: (params = {}) => {
        const q = new URLSearchParams(params).toString();
        return _get(`/api/blog${q ? `?${q}` : ""}`);
    },
    blogCategories: () => _get(`/api/blog/categories`),
    blogPost: (slug) => _get(`/api/blog/${slug}`),
    recipes: (params = {}) => {
        const q = new URLSearchParams(params).toString();
        return _get(`/api/recipes${q ? `?${q}` : ""}`);
    },
    recipe: (slug) => _get(`/api/recipes/${slug}`),
    attractions: () => _get(`/api/attractions`),
    attraction: (slug) => _get(`/api/attractions/${slug}`),

    // Phase 3 — engagement
    reviewsSummary: () => _get(`/api/reviews/summary`),
    reviews: (params = {}) => {
        const q = new URLSearchParams(params).toString();
        return _get(`/api/reviews${q ? `?${q}` : ""}`);
    },
    submitReview: (payload) => _post(`/api/reviews`, payload),
    submitContact: (payload) => _post(`/api/contact`, payload),
    subscribeNewsletter: (payload) => _post(`/api/newsletter/subscribe`, payload),
    faqs: (params = {}) => {
        const q = new URLSearchParams(params).toString();
        return _get(`/api/faqs${q ? `?${q}` : ""}`);
    },
    faqCategories: () => _get(`/api/faqs/categories`),
};
